module.exports = __webpack_public_path__ + "resources/send-message-in-private-293d36b5e446a1af0e64c4ef6a90da1b.svg";